import request from '@/utils/request'

// 账户权限
export function getAccountAuths(options?: any) {
  return request('/role/getResources', options, 'post')
}
